import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { tournoisService, smasheursService } from '../services/api';

const Tournois = () => {
  const [tournois, setTournois] = useState([]);
  const [smasheurs, setSmasheurs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: 'numSaucisse', direction: 'desc' });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [tournoisRes, smasheursRes] = await Promise.all([
        tournoisService.getAll(),
        smasheursService.getAll(),
      ]);
      setTournois(tournoisRes.data);
      setSmasheurs(smasheursRes.data);
    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      setLoading(false);
    }
  };

  const getSmasheurName = (smasheurId) => {
    // smasheurId correspond à idPlayerAPI, pas à l'id local
    const smasheur = smasheurs.find((s) => s.idPlayerAPI === smasheurId);
    return smasheur ? smasheur.pseudo : 'N/A';
  };

  const getSmasheurId = (smasheurApiId) => {
    // Retourne l'ID local du smasheur à partir de son idPlayerAPI
    const smasheur = smasheurs.find((s) => s.idPlayerAPI === smasheurApiId);
    return smasheur ? smasheur.id : null;
  };

  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (columnKey) => {
    if (sortConfig.key !== columnKey) {
      return <i className="bi bi-arrow-down-up ms-1"></i>;
    }
    if (sortConfig.direction === 'asc') {
      return <i className="bi bi-arrow-up ms-1"></i>;
    }
    return <i className="bi bi-arrow-down ms-1"></i>;
  };

  const parseNumSaucisse = (num) => {
    const s = String(num);
    if (s.includes('+')) {
      const [base, add] = s.split('+');
      return parseFloat(base) + parseFloat(add) * 0.1;
    }
    return parseFloat(s.replace(',', '.'));
  };

  // Apply sorting
  const sortedTournois = [...tournois].sort((a, b) => {
    let aValue, bValue;

    if (sortConfig.key === 'numSaucisse') {
      aValue = parseNumSaucisse(a.numSaucisse);
      bValue = parseNumSaucisse(b.numSaucisse);
    } else if (sortConfig.key === 'vainqueur') {
      aValue = getSmasheurName(a.smasheurId).toLowerCase();
      bValue = getSmasheurName(b.smasheurId).toLowerCase();
    }

    if (aValue < bValue) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (aValue > bValue) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="mb-4">
        <h1>
          <i className="bi bi-calendar-event me-2"></i>
          Tournois
        </h1>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th
                    onClick={() => requestSort('numSaucisse')}
                    style={{ cursor: 'pointer', userSelect: 'none' }}
                  >
                    Numéro Saucismash {getSortIcon('numSaucisse')}
                  </th>
                  <th
                    onClick={() => requestSort('vainqueur')}
                    style={{ cursor: 'pointer', userSelect: 'none' }}
                  >
                    Vainqueur {getSortIcon('vainqueur')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedTournois.map((tournoi) => (
                  <tr key={tournoi.id}>
                    <td>
                      <Link
                        to={`/tournois/${tournoi.id}`}
                        className="text-decoration-none"
                      >
                        <span className="badge bg-primary fs-6">
                          Saucismash #{tournoi.numSaucisse}
                        </span>
                      </Link>
                    </td>
                    <td>
                      <Link
                        to={`/smasheurs/${getSmasheurId(tournoi.smasheurId)}`}
                        className="text-decoration-none text-white"
                      >
                        {getSmasheurName(tournoi.smasheurId)}
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tournois;